<mat-grid-list cols="2">
  <mat-grid-tile>
    <div [chart]="earthMarsDistanceChart"></div>
  </mat-grid-tile>
  <mat-grid-tile>
    <div [chart]="earthMarsPositionChart"></div>
  </mat-grid-tile>
</mat-grid-list>

<!--<table mat-table [dataSource]="enrichedData">-->
<!--  <mat-text-column name="timeSinceJ2000"></mat-text-column>-->

<!--  <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>-->
<!--  <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>-->
<!--</table>-->

<table style="width: 100%">
  <tr>
    <th>Jours depuis J2000</th>
    <th>Jours depuis début mission</th>
    <th>Temps (année)</th>
    <th>Anomalie moyenne Terre</th>
    <th>Anomalie moyenne Mars</th>
    <th>x position Terre</th>
    <th>y position Terre</th>
    <th>x position Mars</th>
    <th>y position Mars</th>
  </tr>
<!--  <tr *ngFor="let r of enrichedData">-->
<!--    <td>{{ r.timeSinceJ2000 }}</td>-->
<!--    <td>{{ r.timeSinceMissionStart }}</td>-->
<!--    <td>{{ r.timeInYears }}</td>-->
<!--    <td>{{ r.earthAverageAnomaly }}</td>-->
<!--    <td>{{ r.marsAverageAnomaly }}</td>-->
<!--    <td>{{ r.earthPositionX }}</td>-->
<!--    <td>{{ r.earthPositionY }}</td>-->
<!--    <td>{{ r.marsPositionX }}</td>-->
<!--    <td>{{ r.marsPositionY }}</td>-->
<!--  </tr>-->
</table>
